export default "__VITE_ASSET__DChBAvBo__"